import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import * as Apollo from '@apollo/client';
var defaultOptions = {};
export var GetUserSummaryGamificationQueryDocument = {
  kind: 'Document',
  definitions: [{
    kind: 'OperationDefinition',
    operation: 'query',
    name: {
      kind: 'Name',
      value: 'GetUserSummaryGamificationQuery'
    },
    variableDefinitions: [{
      kind: 'VariableDefinition',
      variable: {
        kind: 'Variable',
        name: {
          kind: 'Name',
          value: 'input'
        }
      },
      type: {
        kind: 'NonNullType',
        type: {
          kind: 'NamedType',
          name: {
            kind: 'Name',
            value: 'UserSummaryInput'
          }
        }
      }
    }],
    selectionSet: {
      kind: 'SelectionSet',
      selections: [{
        kind: 'Field',
        name: {
          kind: 'Name',
          value: 'gamification_v2'
        },
        selectionSet: {
          kind: 'SelectionSet',
          selections: [{
            kind: 'Field',
            name: {
              kind: 'Name',
              value: 'get_allowed_user_summary_by_collaborator'
            },
            arguments: [{
              kind: 'Argument',
              name: {
                kind: 'Name',
                value: 'input'
              },
              value: {
                kind: 'Variable',
                name: {
                  kind: 'Name',
                  value: 'input'
                }
              }
            }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{
                kind: 'Field',
                name: {
                  kind: 'Name',
                  value: '__typename'
                }
              }, {
                kind: 'InlineFragment',
                typeCondition: {
                  kind: 'NamedType',
                  name: {
                    kind: 'Name',
                    value: 'AllowedUserSummaryUserSummaryResponse'
                  }
                },
                selectionSet: {
                  kind: 'SelectionSet',
                  selections: [{
                    kind: 'Field',
                    name: {
                      kind: 'Name',
                      value: 'graphql_operation_id'
                    }
                  }, {
                    kind: 'Field',
                    name: {
                      kind: 'Name',
                      value: 'detail'
                    },
                    selectionSet: {
                      kind: 'SelectionSet',
                      selections: [{
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'id'
                        }
                      }, {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'user_id'
                        }
                      }, {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'currency_point_name'
                        }
                      }, {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'currency_point_status'
                        }
                      }, {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'stats'
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{
                            kind: 'Field',
                            name: {
                              kind: 'Name',
                              value: 'ranking'
                            }
                          }, {
                            kind: 'Field',
                            name: {
                              kind: 'Name',
                              value: 'xp_points'
                            }
                          }, {
                            kind: 'Field',
                            name: {
                              kind: 'Name',
                              value: 'available_points'
                            }
                          }]
                        }
                      }, {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: '__typename'
                        }
                      }]
                    }
                  }, {
                    kind: 'Field',
                    name: {
                      kind: 'Name',
                      value: '__typename'
                    }
                  }]
                }
              }, {
                kind: 'InlineFragment',
                typeCondition: {
                  kind: 'NamedType',
                  name: {
                    kind: 'Name',
                    value: 'ResponseValidationError'
                  }
                },
                selectionSet: {
                  kind: 'SelectionSet',
                  selections: [{
                    kind: 'Field',
                    name: {
                      kind: 'Name',
                      value: 'code'
                    }
                  }, {
                    kind: 'Field',
                    name: {
                      kind: 'Name',
                      value: 'type'
                    }
                  }, {
                    kind: 'Field',
                    name: {
                      kind: 'Name',
                      value: 'message'
                    }
                  }, {
                    kind: 'Field',
                    name: {
                      kind: 'Name',
                      value: '__typename'
                    }
                  }]
                }
              }, {
                kind: 'InlineFragment',
                typeCondition: {
                  kind: 'NamedType',
                  name: {
                    kind: 'Name',
                    value: 'ResponseInternalError'
                  }
                },
                selectionSet: {
                  kind: 'SelectionSet',
                  selections: [{
                    kind: 'Field',
                    name: {
                      kind: 'Name',
                      value: 'code'
                    }
                  }, {
                    kind: 'Field',
                    name: {
                      kind: 'Name',
                      value: 'type'
                    }
                  }, {
                    kind: 'Field',
                    name: {
                      kind: 'Name',
                      value: 'message'
                    }
                  }, {
                    kind: 'Field',
                    name: {
                      kind: 'Name',
                      value: '__typename'
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }]
};

/**
 * __useGetUserSummaryGamificationQueryQuery__
 *
 * To run a query within a React component, call `useGetUserSummaryGamificationQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserSummaryGamificationQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserSummaryGamificationQueryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUserSummaryGamificationQueryQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useQuery(GetUserSummaryGamificationQueryDocument, options);
}
export function useGetUserSummaryGamificationQueryLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(GetUserSummaryGamificationQueryDocument, options);
}